import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Card, Modal, Form, Button } from 'react-bootstrap';
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { encode } from 'base-64';
import './UserProfilePage.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { formatPhoneNumber } from "../../constant/countryCodes";
import moment from "moment";

export default function ClinicViewPage() {
    const { t } = useContext(TranslatorContext);
    const [content, setContent] = useState(0);
    const { clinic_id } = useParams();
    const [Data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showImagePopup, setShowImagePopup] = useState(false);

    const [service, setservice] = useState([]);
    const [doctor, setdoctor] = useState([]);
    const [appointment, setappointment] = useState([]);
    const [consultation, setconsultation] = useState([]);
    const [Review, setReview] = useState([]);



    const contentTypes = {
        service: 0,
        doctor: 1,
        appointment: 2,
        consultation: 3,
        ratings: 4
    };
    const handleButtonClick = (contentType) => {
        setContent(contentTypes[contentType]);
    };


    const getData = () => {
        setLoading(true);
        setNotFound(false);
        axios.post(API_URL + '/view_clinic_by_Id', { clinic_id })
            .then((res) => {
                const clinic = res.data?.clinic_arr?.[0];
                if (clinic) {
                    setData(clinic);
                    setservice(clinic.service_arr || []);
                    setdoctor(clinic.doctor_arr || []);
                    setappointment(clinic.fetchAppointment_arr || []);
                    setconsultation(clinic.fetchConsultation_arr || []);
                    fetchRatings();
                } else {
                    setNotFound(true);
                }
            })
            .catch(() => {
                setNotFound(true);
            })
            .finally(() => setLoading(false));
    };

    const fetchRatings = () => {
        axios.post(API_URL + '/fetch_rating', { type: 1, doctor_id: clinic_id }).then((response) => {
            setReview(response.data.rating_arr || []);
        }).catch(() => {});
    };

    useEffect(() => {
        getData();
    }, []);

    const handleImageClick = (imageUrl) => {
        setEnlargedImage(imageUrl);
        setShowImagePopup(true);
    };

    const handleCloseImage = () => {
        setEnlargedImage(null);
        setShowImagePopup(false);
    };

    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('clinic_details')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item">
                                <Link to={`${APP_PREFIX_PATH + '/manage-clinics'}`} className="mc-breadcrumb-link">{t('clinic')}</Link>
                            </li>
                            <li className="mc-breadcrumb-item">{t('clinic_list')}</li>
                        </ul>
                    </div>
                </div>
            </Col>

            {loading && (
                <div className="mc-card p-lg-4 text-center py-5">
                    <PulseLoader color="#0857f5" loading={true} size={12} />
                    <p className="mt-3 mb-0 text-muted">{t('loading') || 'Loading...'}</p>
                </div>
            )}

            {!loading && notFound && (
                <div className="mc-card p-lg-4 text-center py-5">
                    <p className="text-muted mb-3">{t('clinic_not_found') || 'Clinic not found.'}</p>
                    <Link to={`${APP_PREFIX_PATH}/manage-clinics`} className="btn btn-primary">{t('back_to_list') || 'Back to list'}</Link>
                </div>
            )}

            {!loading && Data && (
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={5}>
                        <h6 className="mc-divide-title mb-4">{t('')}</h6>
                        <div className="mc-user-group">
                            <img
                                src={Data.image ? `${Data.image}` : `image-1720095670109.png`}
                                alt="Profile"
                                style={{ width: '15rem', height: '15rem', borderRadius: '5%', cursor: 'pointer' }}
                                onClick={() => handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`);
                                    }
                                }}
                                role="button"
                                tabIndex={0}
                            />
                            {showImagePopup && (
                                <div
                                    className="enlarged-image-overlay"
                                    onClick={handleCloseImage}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            handleCloseImage();
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <span
                                        className="close-button"
                                        onClick={handleCloseImage}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleCloseImage();
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        &times;
                                    </span>
                                    <img
                                        src={enlargedImage}
                                        alt="Enlarged Profile"
                                        className="enlarged-image"
                                        style={{ width: '30rem', height: '30rem' }}
                                    />
                                </div>
                            )}
                        </div>
                    </Col>
                    <Col xl={7}>
                        <h6 className="mc-divide-title mb-4">{t('clinic_details')}</h6>
                        <div className="mc-product-view-info-group">
                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('name')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.clinic_name}
                                            </span>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('email')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.clinic_email}
                                            </span>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('mobile')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {formatPhoneNumber(Data.clinic_mobile)}
                                            </span>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('country')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.clinic_city}
                                            </span>
                                        </div>

                                    </div>
                                    {/* <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('service_name')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">

                                            {Data.service_arr && Data.service_arr.map((service, index) => (

                                                <span style={{ fontWeight: '400', wordWrap: 'break-word' }}>
                                                    {service.service_name},
                                                </span>


                                            ))}



                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('doctor_name')}:
                                            </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            {Array.isArray(Data.doctor_arr) && Data.doctor_arr.length > 0 ? (
                                                Data.doctor_arr.map((doctor, index) => (
                                                    <span key={index} style={{ fontWeight: '400', wordWrap: 'break-word' }}>
                                                        {doctor.doctor_name ? doctor.doctor_name : 'NA'}
                                                        {index !== Data.doctor_arr.length - 1 && ', '}
                                                    </span>
                                                ))
                                            ) : (
                                                'NA'
                                            )}
                                        </div>

                                    </div> */}

                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('commission')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.commission} %
                                            </span>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('location')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.location || 'NA'}
                                            </span>
                                        </div>

                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>
                                                {t('about_clinic')} :
                                            </h6>

                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.about_clinic || 'NA'}
                                            </span>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <h6 className="mc-divide-title mb-4 mt-3">{t('clinic_images')}</h6>
                        <div className=" row">
                            {Data.Image_arr && Data.Image_arr.length > 0 ? (
                                Data.Image_arr.map((imageObj, index) => (

                                    <div key={index} className="col-lg-3  mb-3">
                                        <img
                                            src={imageObj.image ? `${imageObj.image}` : `image-1720095670109.png`}
                                            alt={`Clinic Image ${index + 1}`}
                                            style={{ width: '100%', height: '11rem', borderRadius: '5%', cursor: 'pointer', objectFit: 'cover' }}
                                            onClick={() => handleImageClick(imageObj.image ? `${imageObj.image}` : `image-1720095670109.png`)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleImageClick(imageObj.image ? `${imageObj.image}` : `image-1720095670109.png`);
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        />
                                    </div>

                                ))
                            ) : (
                                <p>{t('no_images_available')}</p>
                            )}
                            {showImagePopup && (
                                <div
                                    className="enlarged-image-overlay"
                                    onClick={handleCloseImage}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            handleCloseImage();
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <span
                                        className="close-button"
                                        onClick={handleCloseImage}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleCloseImage();
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        &times;
                                    </span>
                                    <img
                                        src={enlargedImage}
                                        alt="Enlarged Clinic Image"
                                        className="enlarged-image"
                                        style={{ width: '30rem', height: '30rem' }}
                                    />
                                </div>
                            )}
                        </div>
                    </Col>

                </Row>

                <Card.Body className="mt-5">
                    <Form>
                        <nav className="navbar navbar-expand-lg navbar-light navBar">
                            <div
                                className="container mobile"
                                id="container-div"
                                style={{ marginTop: '-2rem', width: '22rem', borderRadius: '5px', marginLeft: '0rem' }}
                            >
                                <button
                                    className={`btn btn-outline-success me-2 mb-2 btn-content ${content === contentTypes.service ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('service')}
                                >
                                    {t('clinic_service')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.doctor ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('doctor')}
                                >
                                    {t('doctors')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2 mb-2 btn-content ${content === contentTypes.appointment ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('appointment')}
                                >
                                    {t('appointment')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.consultation ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('consultation')}
                                >
                                    {t('consultation')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.ratings ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('ratings')}
                                >
                                    {t('ratings')}
                                </button>
                            </div>
                        </nav>

                        {content === 0 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>


                                                <th>{t("image")}</th>
                                                <th>{t("service_name")} ( {t("english")} )</th>
                                                <th>{t("service_name")} ( {t("arabic")} )</th>
                                                <th>{t("createtime")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">

                                            {service && service.length > 0 ? (
                                                service.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>

                                                        <td title={item.service_name}>
                                                            <div className="mc-table-profile">
                                                                <img
                                                                    src={item.service_image ? `${item.service_image}` : `doctor_placeholder.webp`}
                                                                    alt="Profile"
                                                                    style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                                                                />
                                                            </div>
                                                        </td>

                                                        <td>{item.service_name || 'NA'}</td>
                                                        <td>{item.service_name_arabic || 'NA'}</td>

                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>


                                    </table>

                                </div>
                            </div>
                        )}

                        {content === 1 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>

                                                <th>{t("image")}</th>
                                                <th>{t("doctor_name")}</th>

                                                <th>{t("createtime")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">
                                            {doctor && doctor.length > 0 ? (
                                                doctor.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td title={item.service_name}>
                                                            <div className="mc-table-profile">
                                                                <img
                                                                    src={item.image ? `${item.image}` : `doctor_placeholder.webp`}
                                                                    alt="Profile"
                                                                    style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <Link to={`${APP_PREFIX_PATH}/doctor-view/${encode(item.doctor_id)}`} style={{ textDecoration: 'underline', color: 'blue' }}><td>{item.doctor_name || 'NA'}</td></Link>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table >

                                </div>
                            </div>
                        )}
                        {content === 2 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>


                                                <th>{t("user_name")}</th>
                                                <th>{t("doctor_name")}</th>
                                                <th>{t("service_name")}</th>
                                                <th>{t("status")}</th>
                                                <th>{t("createtime")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">
                                            {appointment && appointment.length > 0 ? (
                                                appointment.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td>{item.user_name || 'NA'}</td>
                                                        <td>{item.assigned_doctor || 'NA'}</td>
                                                        <td>{item.service_name || 'NA'}</td>
                                                        <td>
                                                            {item.appointment_approved === 0 ? (
                                                                <p className="pendingg">Pending</p>
                                                            ) : item.appointment_approved === 1 ? (
                                                                <p className="approvedd">Approved</p>
                                                            ) : (
                                                                <p className="rejectedd">Rejected</p>
                                                            )}
                                                        </td>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table >

                                </div>
                            </div>
                        )}
                        {content === 3 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>


                                                <th>{t("user_name")}</th>

                                                <th>{t("doctor_name")}</th>
                                                <th>{t("service_name")}</th>
                                                <th>{t("createtime")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">
                                            {consultation && consultation.length > 0 ? (
                                                consultation.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td>{item.user_name || 'NA'}</td>
                                                        <td>{item.assigned_doctor || 'NA'}</td>
                                                        <td>{item.service_name || 'NA'}</td>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table >

                                </div>
                            </div>
                        )}
                        {content === 4 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>
                                                <th>{t("user_name")}</th>
                                                <th>{t("accessibility_rating")}</th>
                                                <th>{t("hospitality_rating")}</th>
                                                <th>{t("cleanliness_rating")}</th>
                                                <th>{t("treatement_quality")}</th>
                                                <th>{t("createtime")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">
                                            {Review && Review.length > 0 ? (
                                                Review.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td>{item.userName || 'NA'}</td>
                                                        <td>{item.accessibility_rating || 'NA'}</td>
                                                        <td>{item.hospitality_rating || 'NA'}</td>
                                                        <td>{item.cleanliness_rating || 'NA'}</td>
                                                        <td>{item.treatement_quality || 'NA'}</td>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table >

                                </div>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </div>
            )}

        </PageLayout>
    );
}
